import CONSTANTS from '../constants'
import { EMPTY_OBJECT } from '../../constants/globalConstants'

const INITIAL_STATE = {
    isFetching: false,
    hasError: false,
    passDetails: EMPTY_OBJECT,
    errorMessage: '',
}

const passDetailsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CONSTANTS.PASS_DETAILS_REQUEST:
            return {
                ...state,
                isFetching: true,
                errorMessage: ''
            }
        case CONSTANTS.PASS_DETAILS_SUCCESS:
            return {
                ...state,
                isFetching: false,
                passDetails: action.data,
                hasError: false,
                errorMessage: ''
            }
        case CONSTANTS.PASS_DETAILS_FAILURE:
            return {
                ...state,
                isFetching: false,
                hasError: true,
                errorMessage: 'There is some Error'
            }
        default:
            return state
    }
}

export default passDetailsReducer
